import { autoinject, computedFrom } from 'aurelia-framework';
import { WidgetController } from 'controls/as-widget-container';
import { WidgetBase } from 'support/base_classes/widget-base';
import { SystemUserWrapper } from 'model/support-types';
import { LookupsService } from 'services/lookups-service';
import { ValidationRules } from 'aurelia-validation';

@autoinject
export class AdminUserSelectorWidget extends WidgetBase<SystemUserWrapper, WidgetController> {
  constructor(private lookups: LookupsService) {
    super();
  }

  changed() {
    ValidationRules
      .ensureObject<SystemUserWrapper>().required()
      .ensure(model => model.user).displayName('Employee').required()
      .on(this.model);
  }

  @computedFrom('model.user')
  get userGroupLabel() {
    const labels = [this.model.user?.jobTitle, this.model.user?.mail, this.model.user?.phone].filter(l => l != null);
    return labels.length > 0 ? labels : 'Employee';
  }

  usersLookupOptions = this.lookups.getUsersLookupOptions();
}
